import React from 'react';
import { Row, Col, Form, Spinner } from 'react-bootstrap';
import {useTranslation} from 'react-i18next'
const UserInfoSection = ({ currentUser }) => {

    const {t} = useTranslation('staffInformation');
    if (!currentUser) {
        return <Spinner animation="border" size="sm" className="me-2" />;
    }

    return (
        <Row>
            <Col md={6}>
                <Form.Group controlId="firstame">
                    <Form.Label>{t('userInfo.firstName')}</Form.Label>
                    <Form.Control
                        type="text"
                        value={currentUser.firstName || ''}
                        readOnly
                    />
                </Form.Group>
            </Col>
            <Col md={6}>
                <Form.Group controlId="lastName">
                    <Form.Label>{t('userInfo.lastName')}</Form.Label>
                    <Form.Control
                        type="text"
                        value={currentUser.lastName || ''}
                        readOnly
                    />
                </Form.Group>
            </Col>
        </Row>
    );
};

export default UserInfoSection;
